import React from 'react';
import Rating from 'react-rating';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { Tooltip } from '@chakra-ui/react';
import ConditionalWrapper from '@interness/web-core/src/components/structure/ConditionalWrapper/ConditionalWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";
const RatingStars = _ref => {
  let {
    rating,
    count,
    showTooltip
  } = _ref;
  return ___EmotionJSX(ConditionalWrapper, {
    condition: showTooltip,
    wrapper: children => ___EmotionJSX(Tooltip, {
      label: `Basierend auf ${count} Bewertungen`
    }, children)
  }, ___EmotionJSX("span", null, ___EmotionJSX(Rating, {
    initialRating: rating,
    readonly: true,
    emptySymbol: ___EmotionJSX(FaRegStar, {
      fill: "#ffc107"
    }),
    fullSymbol: ___EmotionJSX(FaStar, {
      fill: "#ffc107"
    })
  })));
};
RatingStars.defaultProps = {
  showTooltip: false
};
export default RatingStars;